// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function throttleQueue(fn: Function, interval: number) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const queue: Array<any> = []
  let isProcessing = false

  const processQueue = () => {
    if (queue.length === 0) {
      isProcessing = false
      return
    }

    isProcessing = true
    const { context, args } = queue.shift()
    fn.apply(context, args)

    setTimeout(processQueue, interval)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    queue.push({ context: this, args })
    if (!isProcessing) {
      processQueue()
    }
  }
}
